/**
 * "Service Required" options for public forms — must match `solutions[].title` on Services page.
 * Update Services.js and this file together if offerings change.
 */
export const WEBSITE_SERVICE_INTEREST_OPTIONS = [
  'Safety Valve and Breather Valves',
  'Control & Isolation Valves Servicing & Refurbishment',
  'ARC Valve Service',
  'Electric & Pneumatic Actuator Maintenance',
  'Pump Services',
  'Genuine Spares Supply',
  'Workshop Support Services'
];
